import { Channel } from "./channel";
import { IChannel, IChannelData } from "./channel.types";

export const mockChannelData = (): IChannelData[] => [
  {
    id: 11,
    text: "Channel 2",
  },
  {
    id: 12,
    text: "Channel 3",
  },
  {
    id: 10,
    text: "Channel 1",
  },
];

export const mockChannel = (data: IChannelData[] = mockChannelData()): IChannel[] =>
  data.map((item) => new Channel(item));
